<script setup lang="ts">
import SocialMediaButtons from "@/components/Common/SocialMediaButtons.vue";
import SubscriptionsHolder from "@/components/RegistrationPage/MobileVersion/SubscriptionsHolder.vue";
import SelectedBonuses from "@/components/RegistrationPage/MobileVersion/SelectedBonuses.vue";
</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'RegistrationPageMobileVersionContentHolder',
})
</script>

<template>
    <div class="contentBox">
        <div class="d-flex flex-column justify-content-start align-items-center gap-6">
            <div>
                <div class="choiceLabel">Выбери свой пропуск!</div>
                <div class="choiceDescription">Почитать, что такое пропуск и ЗБТ, можно на <router-link to="/">главной странице</router-link>.</div>
                <div class="choiceDescription">Каждый следующий уровень пропуска содержит все бонусы от предыдущего.</div>
                <div class="choiceDescription">Уже купил пропуск, но хочешь его проапгрейдить? Введи e-mail, на который зарегистрировался ранее, и следуй инструкции!</div>
            </div>

            <div class="main">
                <SubscriptionsHolder/>
                <SelectedBonuses/>
            </div>
        </div>

        <div class="footer d-flex flex-row justify-content-center align-items-center">
            <SocialMediaButtons/>

            <div class="contacts">
                <div class="line">
                    <i class="bi bi-envelope-at"></i>
                    <span>admin@scouts.su</span>
                </div>
                <div class="line">
                    <i class="bi bi-person-vcard"></i>
                    <span>ИНН 772014130906</span>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.contentBox {
    position: relative;

    width: 100%;
    max-width: 450px;
    flex: 1;
    justify-content: space-around;

    display: flex;
    flex-direction: column;
    gap: 30px;
}

.choiceLabel {
    width: 100%;
    text-align: center;
    font-size: 20px;
    color: rgb(220, 220, 220);
    text-shadow: 2px 2px 5px black;
}

.choiceDescription {
    width: 100%;
    text-align: center;
    font-size: 16px;
    color: rgb(122, 115, 115);

    a {
        color: rgb(194, 192, 192);
        text-decoration: underline;
    }
}

.main {
    display: flex;
    min-height: 100%;
    flex-direction: column;
    flex: 1;
    gap: 75px;
}

.footer {
    position: relative;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 4px;
    padding: 5px;
    color: #444444;

    margin: 50px 0 0 0;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 15px;
}

.contacts {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
}

.line {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
    font-size: 13px;
}
</style>
